import { assign } from "lodash";
import { ChangeDetectionStrategy, Component } from '@angular/core';
import * as FlatModels from '@medsurf/flat-models';
import { BaseQuestionComponent } from '../base-question/base-question.component';
import { FormControl, FormGroup } from "@angular/forms";
import { ZodSharedValidator } from "@medsurf/flat-validators";

@Component({
    selector: 'medsurf-quiz-freetext-question',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './freetext-question.component.html',
    styleUrls: ['./freetext-question.component.scss'],
    standalone: false
})
export class FreetextQuestionComponent extends BaseQuestionComponent<FlatModels.QuestionEntityModels.FreeTextQuestion> {
  override form = new FormGroup(
    {
      content: new FormControl(''),
      explanation: new FormControl(''),
      solutionText: new FormControl(''),
    },
    {
      validators: ZodSharedValidator.validate(
        FlatModels.QuestionEntityModels.FreeTextQuestionSchema.pick({
          content: true,
          explanation: true,
          solutionText: true
        })
      ),
      updateOn: 'change'
    }
  );

  override updateForm() {
    if (this.index !== undefined && this.question) {
      let update = false;
      if (this.question.content !== this.form.value.content
        || this.question.explanation !== this.form.value.explanation
        || this.question.solutionText !== this.form.value.solutionText) {
        update = true;
      }
      if (update) {
        // Update Data
        this.form.reset(this.question);
        this.isSubmitted.set(false);
      }
    }
  }

  override onSubmit() {
    if (this.isSubmitted() || this.form.invalid || !this.question) {
      return;
    }
    this.isSubmitted.set(true);
    
    // Update Question
    const question = assign(this.question, this.form.value);

    // Request Update Question
    this.slideAuthorFacade.requestUpdateQuestion(question, 'history.question_update').subscribe({
      error: (result) => {
        ZodSharedValidator.handleError(result, this.alertControlFacade, this.form);
        this.isSubmitted.set(false);
      },
      next: () => {
        this.isSubmitted.set(false);
      }
    });
  }
}
